import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '../../../services/custom-validator';
import {HumanInteractionService} from '../../../services/human-interaction.service';
import {ServiceConfigurationBatcherComponent} from '../service-configuration-batcher/service-configuration-batcher.component';
import {EditQueueColumnModalComponent} from '../common/edit-queue-column-modal/edit-queue-column-modal.component';
import {BusinessProcessService} from '../../../services/business-process.service';
import {take} from 'rxjs/operators';
import {EditQueueColorModalComponent} from '../common/edit-queue-color-modal/edit-queue-color-modal.component';
import {QueueColumnsPreviewModalComponent} from '../common/queue-columns-preview-modal/queue-columns-preview-modal.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-interaction-queue-config',
  templateUrl: './interaction-queue-config.component.html',
  styleUrls: ['./interaction-queue-config.component.css']
})
export class InteractionQueueConfigComponent implements OnInit {
  componentForm: FormGroup;
  availableBusinessProcessList: any[];
  error;
  submitted;
  pleaseWait = false;
  updateInteractionQueue = true;
  get formData() { return this.componentForm.controls; }

  constructor(
    private humanInteractionService: HumanInteractionService,
    private bpService: BusinessProcessService,
    private modalService: GenericModalService,
    private formBuilder: FormBuilder, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted= false;
    this.createForm();
    this.loadConfig();

  }

  createForm() {
    this.componentForm = this.formBuilder.group({
      orderDirection:[0],
      orderByColumnId: null,
      columns:[[]],
      colors:[[]]
    });
  }

  loadBps() {
    this.error = '';
    this.pleaseWait = true;
    this.bpService.getAllBusinessProcessesPublishedWithStates()
      .subscribe(result => {
        if (result) {
          this.availableBusinessProcessList = result;
          this.pleaseWait = false;

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  loadConfig() {
    this.error = '';
    this.humanInteractionService.getInteractionQueueForEdit()
      .subscribe(result => {
        if (result) {
          this.componentForm.patchValue({
            orderDirection:  result.orderDirection,
            orderByColumnId: result.orderByColumn? result.orderByColumn.id:0,
            columns:  result.columns,
            colors:  result.colors,
          });

          this.pleaseWait = false;
          this.loadBps();
          this.onOrderByColumnChange();

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  destEditColumn: any = EditQueueColumnModalComponent;
  editColumn(column) {
    let param = {bps: this.availableBusinessProcessList, column: column};
    const result$ = this.modalService.showObjModal(this.destEditColumn, 'Configuração da apresentação dos campos', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.columns.value.findIndex(item => item.id == result.id);
          this.formData.columns.value[itemIndex] = result;
        });
    } else {
      this.error = 'Erro: Sessão expirada.';
    }
  }

  columnsPreview: any = QueueColumnsPreviewModalComponent;
  openColumnsPreview() {
    let enabledColumns = this.formData.columns.value.filter(c => c.isEnabled);
    this.modalService.showObjModal(this.columnsPreview, 'Pré-visualização', enabledColumns);
  }

  destEditColor: any = EditQueueColorModalComponent;
  editColor(itemColor: any) {
    let param = {bps: this.availableBusinessProcessList, color: itemColor};
    const result$ = this.modalService.showObjModal(this.destEditColor, 'Configuração da faixa de cores', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.colors.value.findIndex(item =>
            item.businessProcessId == result.oldColor.businessProcessId &&
            item.stateId == result.oldColor.stateId &&
            item.color == result.oldColor.color);
          this.formData.colors.value[itemIndex] = result.newColor;
          this.componentForm.updateValueAndValidity();
        });
    } else {
      this.error = 'Erro: Sessão expirada.';
    }
  }

  removeColor(itemColor: any) {
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão de Cor',
      `Confirma a exclusão da cor?`);
    alert.then((result) => {
      if (result.value){
        this.formData.colors.value.splice(this.formData.colors.value.indexOf(itemColor), 1);
      }
    });


  }

  addColor() {
    let param = {bps: this.availableBusinessProcessList, color: null};
    const result$ = this.modalService.showObjModal(this.destEditColor, 'Configuração da faixa de cores', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          this.formData.colors.value.push(result.newColor);
        });
    } else {
      this.error = 'Erro: Sessão expirada.';
    }
  }

  onOrderByColumnChange() {
    if (this.formData.orderByColumnId.value && this.formData.orderByColumnId.value != 0){
      this.componentForm.get('orderDirection').setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.componentForm.get('orderDirection').clearValidators();
      this.formData.orderDirection.setValue(0);
    }
    this.componentForm.updateValueAndValidity();
  }

  drop(event) {
    let oldColumnOrder = this.formData.columns.value[event.previousIndex].columnOrder;
    let newColumnOrder = this.formData.columns.value[event.currentIndex].columnOrder;

    this.formData.columns.value[event.currentIndex].columnOrder = oldColumnOrder;
    this.formData.columns.value[event.previousIndex].columnOrder = newColumnOrder;
    moveItemInArray(this.formData.columns.value, event.previousIndex, event.currentIndex);
  }


  getBpName(businessProcessId: any) {
    if (!this.availableBusinessProcessList) return null;
    let bp = this.availableBusinessProcessList.filter(bp => bp.businessProcessId == businessProcessId)[0];
    return bp.name;
  }

  getStateName(businessProcessId: any, stateId: any) {
    if (!this.availableBusinessProcessList) return null;
    let bp = this.availableBusinessProcessList.filter(bp => bp.businessProcessId == businessProcessId)[0];
    let filterResult = bp.states.filter(f => f.stateId == stateId);
    if (!filterResult || filterResult.length != 1){
     return "Estado não existe no processo de negócio publicado";
    }
    return filterResult[0].name;
  }

  onSave() {
    this.pleaseWait = true;
    this.submitted = false;
    this.error = "";
    const obj = this.componentForm.getRawValue();
    if (obj.orderDirection){
      obj.orderDirection = Number(obj.orderDirection);
    }
    const columns = obj.columns;
    for (let i = 0; i < obj.columns.length; i++) {
      columns[i].columnOrder = i + 1;
    }
    obj.columns = columns;
    this.humanInteractionService.updateInteractionQueue(obj).subscribe(
      () => {
        if (this.updateInteractionQueue) {
          this.requestRefreshInteractionQueue();
        } else {
          this.showSuccessMessage();
        }
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

  requestRefreshInteractionQueue(){
    this.error = '';
    this.humanInteractionService.requestRefreshInteractionQueue().subscribe(() => {
      this.showSuccessMessage();
    }, error1 => {
      this.pleaseWait = false;
      this.error = "Erro: Falha ao atualizar registros da fila de interação humana: " + error1;
    });
  }

  showSuccessMessage(){
    this.pleaseWait = false;
    this.submitted = true;
    setTimeout(() => {
      this.submitted = false;
    }, 3000);
  }


}
